import { api } from 'services/api';

export class ServiceOrderService {
  async getServiceOrderReport(serviceOrderNumber) {
    return api.get(`/service-order/report/${serviceOrderNumber}`, { responseType: 'blob' });
  }
}

export const serviceOrderService = new ServiceOrderService();
